/** L2/L3: conectores de segurança (catálogo, OpenAPI) e scanners de terceiros (Tenable, Qualys, Rapid7). */
const en = {
  'nav.securityConnectors': 'Security connectors',
  'secc.title': 'Security connectors',
  'secc.sub': 'Read-only connectors to other security tools: devices, findings, identities and cloud resources. Scanner findings join the ones Hive detects, once per device and CVE.',
  'secc.tab.connectors': 'Connectors',
  'secc.tab.findings': 'Findings',
  'secc.lead': 'Each connector reads its tool on a schedule with GET requests only. Secrets stay in the vault.',
  'secc.addCatalog': 'Add from catalog',
  'secc.addOpenApi': 'From OpenAPI',
  'secc.none': 'No security connector yet.',
  'secc.noneText': 'Add one from the catalog (Wiz, Okta, Tenable…) or generate one from the OpenAPI document of the tool.',
  'secc.col.connector': 'Connector',
  'secc.col.state': 'State',
  'secc.col.contents': 'Read',
  'secc.col.lastRun': 'Last run',
  'secc.state.pending': 'Waiting',
  'secc.state.running': 'Reading',
  'secc.state.ok': 'Read',
  'secc.state.error': 'With error',
  'secc.kind.connector': 'Connector',
  'secc.kind.scanner': 'Scanner',
  'secc.kind.openapi': 'From OpenAPI',
  'secc.cat.cnapp': 'CNAPP / CSPM',
  'secc.cat.sase': 'SASE',
  'secc.cat.idp': 'Identity provider',
  'secc.cat.grc': 'GRC',
  'secc.cat.scanner': 'Vulnerability scanner',
  'secc.cat.custom': 'Custom',
  'secc.counts': '{assets} devices ({matched} in the inventory) · {findings} findings · {identities} identities · {cloud} cloud resources',
  'secc.scannerFindings': '{count} findings imported',
  'secc.test': 'Test connection',
  'secc.testOk': 'Connection OK: {message}',
  'secc.testFail': 'Connection failed: {message}',
  'secc.run': 'Run now',
  'secc.running': 'Read started.',
  'secc.import': 'Import file',
  'secc.importTitle': 'Import into {name}',
  'secc.importHint': 'The JSON exported by the scanner (Tenable vulnerabilities export, Qualys host detection in JSON, Rapid7 InsightVM assets with vulnerabilities).',
  'secc.importFile': 'File (.json)',
  'secc.importDone': 'Imported: {assets} devices ({matched} in the inventory), {findings} findings.',
  'secc.importBad': 'The file is not valid JSON.',
  'secc.remove': 'Remove',
  'secc.removeTitle': 'Remove {name}?',
  'secc.removeBody': 'What this connector imported and its secret in the vault are removed. Nothing changes in the other tool.',
  'secc.save': 'Save',
  'secc.saved': 'Connector saved.',
  'secc.f.definition': 'Tool',
  'secc.f.name': 'Name',
  'secc.f.baseUrl': 'Base URL',
  'secc.f.baseUrlHint': 'https:// and public; internal addresses are blocked.',
  'secc.f.baseUrlBad': 'Use an https:// address without user or password.',
  'secc.f.interval': 'Read every (minutes)',
  'secc.f.auth': 'Authentication',
  'secc.f.authHeader': 'API key header',
  'secc.auth.apiKey': 'API key',
  'secc.auth.oauth': 'OAuth 2.0 client credentials',
  'secc.auth.basic': 'User and password',
  'secc.secret.apiKey': 'API key',
  'secc.secret.clientId': 'Client ID',
  'secc.secret.clientSecret': 'Client secret',
  'secc.secret.username': 'User',
  'secc.secret.password': 'Password',
  'secc.secret.accessKey': 'Access key',
  'secc.secret.secretKey': 'Secret key',
  'secc.secretHint': 'Goes to the vault and is never shown again.',
  'secc.entities': 'Brings: {list}',
  'secc.entity.asset': 'Devices',
  'secc.entity.finding': 'Findings',
  'secc.entity.identity': 'Identities',
  'secc.entity.cloud_resource': 'Cloud resources',
  'secc.oa.title': 'Generate a connector from OpenAPI',
  'secc.oa.document': 'OpenAPI document (JSON)',
  'secc.oa.documentHint': 'Paste the openapi.json (or swagger.json) of the tool. Only GET operations are listed.',
  'secc.oa.list': 'List operations',
  'secc.oa.none': 'The document has no GET operation.',
  'secc.oa.operation': 'GET operation',
  'secc.oa.itemsPath': 'Items path',
  'secc.oa.itemsPathHint': 'Where the list is in the response, e.g. data.items (empty = the response itself is the list).',
  'secc.oa.entity': 'Entity',
  'secc.oa.mapping': 'Field mapping',
  'secc.oa.mappingHint': 'External ID and Name are required; a finding also needs CVE.',
  'secc.oa.fieldNone': '(not mapped)',
  'secc.map.extId': 'External ID',
  'secc.map.name': 'Name',
  'secc.map.hostname': 'Hostname',
  'secc.map.ip': 'IP',
  'secc.map.cve': 'CVE',
  'secc.map.severity': 'Severity',
  'secc.map.email': 'Email',
  'secc.fd.lead': 'Each device and CVE once, with every source that reported it. Findings of devices not in the inventory do not appear here.',
  'secc.fd.none': 'No finding yet.',
  'secc.fd.search': 'Search CVE or device',
  'secc.fd.asset': 'Device',
  'secc.fd.cve': 'CVE',
  'secc.fd.severity': 'Severity',
  'secc.fd.sources': 'Sources',
  'secc.fd.lastSeen': 'Last seen',
};

const ptBR: Record<keyof typeof en, string> = {
  'nav.securityConnectors': 'Conectores de segurança',
  'secc.title': 'Conectores de segurança',
  'secc.sub': 'Conectores somente leitura com outras ferramentas de segurança: dispositivos, achados, identidades e recursos de nuvem. Os achados dos scanners se juntam aos que o Hive detecta, um por dispositivo e CVE.',
  'secc.tab.connectors': 'Conectores',
  'secc.tab.findings': 'Achados',
  'secc.lead': 'Cada conector lê a ferramenta dele numa agenda, só com requisições GET. Os segredos ficam no cofre.',
  'secc.addCatalog': 'Adicionar do catálogo',
  'secc.addOpenApi': 'A partir do OpenAPI',
  'secc.none': 'Nenhum conector de segurança ainda.',
  'secc.noneText': 'Adicione um do catálogo (Wiz, Okta, Tenable…) ou gere um a partir do documento OpenAPI da ferramenta.',
  'secc.col.connector': 'Conector',
  'secc.col.state': 'Estado',
  'secc.col.contents': 'Lido',
  'secc.col.lastRun': 'Última execução',
  'secc.state.pending': 'Aguardando',
  'secc.state.running': 'Lendo',
  'secc.state.ok': 'Lido',
  'secc.state.error': 'Com erro',
  'secc.kind.connector': 'Conector',
  'secc.kind.scanner': 'Scanner',
  'secc.kind.openapi': 'Do OpenAPI',
  'secc.cat.cnapp': 'CNAPP / CSPM',
  'secc.cat.sase': 'SASE',
  'secc.cat.idp': 'Provedor de identidade',
  'secc.cat.grc': 'GRC',
  'secc.cat.scanner': 'Scanner de vulnerabilidades',
  'secc.cat.custom': 'Personalizado',
  'secc.counts': '{assets} dispositivos ({matched} no inventário) · {findings} achados · {identities} identidades · {cloud} recursos de nuvem',
  'secc.scannerFindings': '{count} achados importados',
  'secc.test': 'Testar conexão',
  'secc.testOk': 'Conexão OK: {message}',
  'secc.testFail': 'A conexão falhou: {message}',
  'secc.run': 'Executar agora',
  'secc.running': 'Leitura iniciada.',
  'secc.import': 'Importar arquivo',
  'secc.importTitle': 'Importar em {name}',
  'secc.importHint': 'O JSON exportado pelo scanner (exportação de vulnerabilidades do Tenable, detecção de hosts do Qualys em JSON, ativos com vulnerabilidades do Rapid7 InsightVM).',
  'secc.importFile': 'Arquivo (.json)',
  'secc.importDone': 'Importado: {assets} dispositivos ({matched} no inventário), {findings} achados.',
  'secc.importBad': 'O arquivo não é um JSON válido.',
  'secc.remove': 'Remover',
  'secc.removeTitle': 'Remover {name}?',
  'secc.removeBody': 'O que este conector importou e o segredo dele no cofre são removidos. Nada muda na outra ferramenta.',
  'secc.save': 'Salvar',
  'secc.saved': 'Conector salvo.',
  'secc.f.definition': 'Ferramenta',
  'secc.f.name': 'Nome',
  'secc.f.baseUrl': 'URL base',
  'secc.f.baseUrlHint': 'https:// e pública; endereços internos são bloqueados.',
  'secc.f.baseUrlBad': 'Use um endereço https:// sem usuário nem senha.',
  'secc.f.interval': 'Ler a cada (minutos)',
  'secc.f.auth': 'Autenticação',
  'secc.f.authHeader': 'Cabeçalho da chave de API',
  'secc.auth.apiKey': 'Chave de API',
  'secc.auth.oauth': 'OAuth 2.0 client credentials',
  'secc.auth.basic': 'Usuário e senha',
  'secc.secret.apiKey': 'Chave de API',
  'secc.secret.clientId': 'Client ID',
  'secc.secret.clientSecret': 'Client secret',
  'secc.secret.username': 'Usuário',
  'secc.secret.password': 'Senha',
  'secc.secret.accessKey': 'Chave de acesso',
  'secc.secret.secretKey': 'Chave secreta',
  'secc.secretHint': 'Vai para o cofre e não é mostrado de novo.',
  'secc.entities': 'Traz: {list}',
  'secc.entity.asset': 'Dispositivos',
  'secc.entity.finding': 'Achados',
  'secc.entity.identity': 'Identidades',
  'secc.entity.cloud_resource': 'Recursos de nuvem',
  'secc.oa.title': 'Gerar um conector a partir do OpenAPI',
  'secc.oa.document': 'Documento OpenAPI (JSON)',
  'secc.oa.documentHint': 'Cole o openapi.json (ou swagger.json) da ferramenta. Só as operações GET são listadas.',
  'secc.oa.list': 'Listar operações',
  'secc.oa.none': 'O documento não tem operação GET.',
  'secc.oa.operation': 'Operação GET',
  'secc.oa.itemsPath': 'Caminho dos itens',
  'secc.oa.itemsPathHint': 'Onde a lista está na resposta, ex.: data.items (vazio = a própria resposta é a lista).',
  'secc.oa.entity': 'Entidade',
  'secc.oa.mapping': 'Mapeamento dos campos',
  'secc.oa.mappingHint': 'ID externo e Nome são obrigatórios; um achado também precisa de CVE.',
  'secc.oa.fieldNone': '(não mapeado)',
  'secc.map.extId': 'ID externo',
  'secc.map.name': 'Nome',
  'secc.map.hostname': 'Hostname',
  'secc.map.ip': 'IP',
  'secc.map.cve': 'CVE',
  'secc.map.severity': 'Severidade',
  'secc.map.email': 'E-mail',
  'secc.fd.lead': 'Cada dispositivo e CVE uma vez, com todas as fontes que o reportaram. Achados de dispositivos fora do inventário não aparecem aqui.',
  'secc.fd.none': 'Nenhum achado ainda.',
  'secc.fd.search': 'Procurar CVE ou dispositivo',
  'secc.fd.asset': 'Dispositivo',
  'secc.fd.cve': 'CVE',
  'secc.fd.severity': 'Severidade',
  'secc.fd.sources': 'Fontes',
  'secc.fd.lastSeen': 'Visto por último',
};

const es: Record<keyof typeof en, string> = {
  'nav.securityConnectors': 'Conectores de seguridad',
  'secc.title': 'Conectores de seguridad',
  'secc.sub': 'Conectores de solo lectura con otras herramientas de seguridad: dispositivos, hallazgos, identidades y recursos de nube. Los hallazgos de los escáneres se unen a los que Hive detecta, uno por dispositivo y CVE.',
  'secc.tab.connectors': 'Conectores',
  'secc.tab.findings': 'Hallazgos',
  'secc.lead': 'Cada conector lee su herramienta en una agenda, solo con solicitudes GET. Los secretos quedan en la bóveda.',
  'secc.addCatalog': 'Agregar del catálogo',
  'secc.addOpenApi': 'A partir de OpenAPI',
  'secc.none': 'Ningún conector de seguridad todavía.',
  'secc.noneText': 'Agregue uno del catálogo (Wiz, Okta, Tenable…) o genere uno a partir del documento OpenAPI de la herramienta.',
  'secc.col.connector': 'Conector',
  'secc.col.state': 'Estado',
  'secc.col.contents': 'Leído',
  'secc.col.lastRun': 'Última ejecución',
  'secc.state.pending': 'En espera',
  'secc.state.running': 'Leyendo',
  'secc.state.ok': 'Leído',
  'secc.state.error': 'Con error',
  'secc.kind.connector': 'Conector',
  'secc.kind.scanner': 'Escáner',
  'secc.kind.openapi': 'De OpenAPI',
  'secc.cat.cnapp': 'CNAPP / CSPM',
  'secc.cat.sase': 'SASE',
  'secc.cat.idp': 'Proveedor de identidad',
  'secc.cat.grc': 'GRC',
  'secc.cat.scanner': 'Escáner de vulnerabilidades',
  'secc.cat.custom': 'Personalizado',
  'secc.counts': '{assets} dispositivos ({matched} en el inventario) · {findings} hallazgos · {identities} identidades · {cloud} recursos de nube',
  'secc.scannerFindings': '{count} hallazgos importados',
  'secc.test': 'Probar conexión',
  'secc.testOk': 'Conexión OK: {message}',
  'secc.testFail': 'La conexión falló: {message}',
  'secc.run': 'Ejecutar ahora',
  'secc.running': 'Lectura iniciada.',
  'secc.import': 'Importar archivo',
  'secc.importTitle': 'Importar en {name}',
  'secc.importHint': 'El JSON exportado por el escáner (exportación de vulnerabilidades de Tenable, detección de hosts de Qualys en JSON, activos con vulnerabilidades de Rapid7 InsightVM).',
  'secc.importFile': 'Archivo (.json)',
  'secc.importDone': 'Importado: {assets} dispositivos ({matched} en el inventario), {findings} hallazgos.',
  'secc.importBad': 'El archivo no es un JSON válido.',
  'secc.remove': 'Eliminar',
  'secc.removeTitle': '¿Eliminar {name}?',
  'secc.removeBody': 'Se elimina lo que este conector importó y su secreto en la bóveda. Nada cambia en la otra herramienta.',
  'secc.save': 'Guardar',
  'secc.saved': 'Conector guardado.',
  'secc.f.definition': 'Herramienta',
  'secc.f.name': 'Nombre',
  'secc.f.baseUrl': 'URL base',
  'secc.f.baseUrlHint': 'https:// y pública; las direcciones internas se bloquean.',
  'secc.f.baseUrlBad': 'Use una dirección https:// sin usuario ni contraseña.',
  'secc.f.interval': 'Leer cada (minutos)',
  'secc.f.auth': 'Autenticación',
  'secc.f.authHeader': 'Encabezado de la clave de API',
  'secc.auth.apiKey': 'Clave de API',
  'secc.auth.oauth': 'OAuth 2.0 client credentials',
  'secc.auth.basic': 'Usuario y contraseña',
  'secc.secret.apiKey': 'Clave de API',
  'secc.secret.clientId': 'Client ID',
  'secc.secret.clientSecret': 'Client secret',
  'secc.secret.username': 'Usuario',
  'secc.secret.password': 'Contraseña',
  'secc.secret.accessKey': 'Clave de acceso',
  'secc.secret.secretKey': 'Clave secreta',
  'secc.secretHint': 'Va a la bóveda y no se vuelve a mostrar.',
  'secc.entities': 'Trae: {list}',
  'secc.entity.asset': 'Dispositivos',
  'secc.entity.finding': 'Hallazgos',
  'secc.entity.identity': 'Identidades',
  'secc.entity.cloud_resource': 'Recursos de nube',
  'secc.oa.title': 'Generar un conector a partir de OpenAPI',
  'secc.oa.document': 'Documento OpenAPI (JSON)',
  'secc.oa.documentHint': 'Pegue el openapi.json (o swagger.json) de la herramienta. Solo se listan las operaciones GET.',
  'secc.oa.list': 'Listar operaciones',
  'secc.oa.none': 'El documento no tiene operación GET.',
  'secc.oa.operation': 'Operación GET',
  'secc.oa.itemsPath': 'Ruta de los elementos',
  'secc.oa.itemsPathHint': 'Dónde está la lista en la respuesta, p. ej. data.items (vacío = la respuesta misma es la lista).',
  'secc.oa.entity': 'Entidad',
  'secc.oa.mapping': 'Mapeo de los campos',
  'secc.oa.mappingHint': 'ID externo y Nombre son obligatorios; un hallazgo también necesita CVE.',
  'secc.oa.fieldNone': '(sin mapear)',
  'secc.map.extId': 'ID externo',
  'secc.map.name': 'Nombre',
  'secc.map.hostname': 'Hostname',
  'secc.map.ip': 'IP',
  'secc.map.cve': 'CVE',
  'secc.map.severity': 'Severidad',
  'secc.map.email': 'Correo',
  'secc.fd.lead': 'Cada dispositivo y CVE una vez, con todas las fuentes que lo reportaron. Los hallazgos de dispositivos fuera del inventario no aparecen aquí.',
  'secc.fd.none': 'Ningún hallazgo todavía.',
  'secc.fd.search': 'Buscar CVE o dispositivo',
  'secc.fd.asset': 'Dispositivo',
  'secc.fd.cve': 'CVE',
  'secc.fd.severity': 'Severidad',
  'secc.fd.sources': 'Fuentes',
  'secc.fd.lastSeen': 'Visto por última vez',
};

export const connectorsMessages = { en, 'pt-BR': ptBR, es } as const;
